import { SxProps } from "@mui/material";

export const sxMessageInput: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  maxWidth: '690px',
  fontSize: '14px',
  width: '100%'
}

export const sxAttachFileButton: SxProps = {
  alignSelf: 'flex-end',
  height: '44px'
}